import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Building, BuildingOpeningHour } from '../../models';

import { ApiService, ParamsObject } from '../../utils/api.service';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class BuildingOpeningHoursService {

  path = 'building_opening_hours';
  constructor(
    private apiService: ApiService,
  ) {
  }

  edit(openingHours): Observable<Building> {
    return this.apiService.put(this.path + '/' + openingHours.id, openingHours);
  }

  getAll(params: ParamsObject = {}): Observable<BuildingOpeningHour[]> {
    const httpParameters = new HttpParams({
      fromObject: params,
    });

    return this.apiService.get(this.path, httpParameters);
  }
}
